import React, { useEffect } from "react";
import GlobalState from "../components/context/GlobalState";
import { MessageContextProvider } from "../components/context/MessageContext";
import PropType from "prop-types";
import Meta from "../components/common/Meta";
import { ToastContainer } from "react-toastify";
import Router from "next/router";
import api from "../components/settings/api";
import Script from "next/script";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import { initSentry } from "../utils/sentry";

// Styles
import theme from "../styles/themeMui/theme";
import "../styles/common/index.scss";
import "../styles/landingpage/index.scss";
import "../styles/dashboard/index.scss";
import "../styles/otherpages/index.scss";
import "react-toastify/dist/ReactToastify.min.css";

// Polyfills
import "intersection-observer";
import ProgressBar from "../components/common/ProgressBar";
import Cookies from "universal-cookie";
import { AuthProvider, ProtectRoute } from "components/context/auth";
import ErrorBoundary from "../components/common/ErrorBoundary";

// Only access cookies on client side to avoid SSR issues
let cookies;
if (typeof window !== "undefined") {
  cookies = new Cookies();
  if (cookies.get("token")) {
    api.defaults.headers.common["Authorization"] =
      "Bearer " + cookies.get("token");
  }
}

function MyApp({ Component, pageProps }) {
  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return;
    }

    initSentry();

    const jssStyles = document.getElementById("jss-server-side");
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }

    let utm_campaign;
    try {
      utm_campaign = Router.router?.query?.utm_campaign;
    } catch (error) {
      utm_campaign = null;
    }

    const sendUpdate = async (codeToSend) => {
      try {
        await api.put("/api/v1/coupons/code/click", {
          code: codeToSend,
        });
      } catch (error) {
        // Non-critical analytics call; fail silently
      }
    };

    if (cookies && cookies.get("token")) {
      if (utm_campaign) {
        sendUpdate(utm_campaign);
      } else {
        sendUpdate("no_code");
      }
    }

    if (window.location.hash === "#_=_") {
      if (history.replaceState) {
        var cleanHref = window.location.href.split("#")[0];
        history.replaceState(null, null, cleanHref);
      } else {
        window.location.hash = "";
      }
    }
  }, []);

  return (
    <>
      <Script
        async
        src={"https://www.googletagmanager.com/gtag/js?id=GTM-TJLLGLR"}
      />
        <Script>
          {`window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag("js", new Date());
                    gtag("config", "GTM-TJLLGLR");`}
        </Script>
      <Meta />
      <ToastContainer />
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <ErrorBoundary>
            <GlobalState {...pageProps}>
              <ProgressBar />
              <MessageContextProvider>
                <AuthProvider>
                  <ProtectRoute>
                    <Component {...pageProps} />
                  </ProtectRoute>
                </AuthProvider>
              </MessageContextProvider>
            </GlobalState>
          </ErrorBoundary>
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
}
export default MyApp;

MyApp.propTypes = {
  Component: PropType.func,
  pageProps: PropType.object,
};
